import React from 'react';
// import { faClock, faMapMarker, faPhone } from '@fortawesome/free-solid-svg-icons';
import support from '../../../images/support.png'
import home from '../../../images/home.png'
import call from '../../../images/call.png'
import email from '../../../images/email.png'
import social from '../../../images/social.png'
import certified from '../../../images/certified.png'
import ContactCard from '../ContactCard/ContactCard';

const infosData = [
    {
        title: 'My Address',
        description: 'Nilphamari, Bangladesh',
        // icon: faClock,
        icon: home,
        background: 'light'
    },
    {
        title: 'Phone Number',
        description: '+880 1752-082739',
        // icon: faMapMarker,
        icon: call,
        background: 'light'
    },
    {
        title: 'Email Address',
        description: "faiyadahmedsudipto@gmail.com",
        // icon: faPhone,
        icon: email,
        background: 'light'
    },
    {
        title: 'Connect With Me',
        description: "",
        accountOne: "Linked In",
        accountTwo: "Github",
        accountThree: "Facebook",
        // icon: faPhone,
        icon: social,
        background: 'light'
    }
]
const ContactInfo = () => {
    return (
        // <section className="d-flex justify-content-center">
        <section id="contact" className="mt-5 mb-3">
            <div className="text-center">
                <h2 className="fw-bold">CONTACT</h2>
                <h5 className="text-muted">Hire Me For Your Next Projects</h5>
            </div>
            <div className="d-flex justify-content-center">
                <div className="w-75 row ">
                    {
                        infosData.map(info => <ContactCard info={info} key={info.title}></ContactCard>)
                    }
                </div>
            </div>
        </section>
    );
};

export default ContactInfo;